import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { flowDatePicker } from './datepicker.theme';

export const flowDateTimePicker: Components<Theme>['MuiDateTimePicker'] = {
  ...(flowDatePicker as Components<Theme>['MuiDateTimePicker']),
  defaultProps: {
    ...(flowDatePicker.defaultProps as Components<Theme>['MuiDateTimePicker']['defaultProps']),
    views: ['day', 'month', 'year', 'hours', 'minutes'],
  },
};

export const flowDesktopDateTimePicker: Components<Theme>['MuiDesktopDateTimePicker'] =
  flowDateTimePicker as Components<Theme>['MuiDesktopDateTimePicker'];

export const flowStaticDateTimePicker: Components<Theme>['MuiStaticDateTimePicker'] =
  flowDateTimePicker as Components<Theme>['MuiStaticDateTimePicker'];
